import { ScoreExplanationProps } from "@/api/useTriage.types"
import { Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { useFeatureFlags } from "@/hooks/useUser"
import { TitleKodemScore } from "@/molecules/KodemScoreCell/TitleKodemScore"
import { getItems } from "@/molecules/ScoreExplanation/getItems"
import { OverviewCardTemplate } from "@/organisms/Drawers/components/PackageDrawer/components/OverviewCardTemplate"

import styles from "./ScoreCardExplanation.module.scss"

export const ScoreCardExplanation = ({
  record
}: {
  record: ScoreExplanationProps
}) => {
  const { t } = useTranslation()
  const internetFacingFF = useFeatureFlags("internetFacingIntegration")

  if (!record) return null

  const { kodemScore } = record

  return (
    <OverviewCardTemplate
      title={<TitleKodemScore score={kodemScore} />}
      subtitle={
        <Text className={styles.scoreBreakdown}>
          {t("triage.drawer.kodemScoreBreakdown")}
        </Text>
      }
      items={getItems(record, { t, internetFacingFF })}
      classes={{
        title: styles.title,
        body: styles.cardBody,
        card: styles.card
      }}
    />
  )
}
